import { styled, Typography } from '@mui/material';
import { CustomBox } from '../layout.styles';

export const CustomMainBar = styled(CustomBox)(() => ({
    width: '75%',
}));

export const CustomMainBarTitle = styled(Typography)(() => ({
    fontSize: '30px',
    fontStyle: 'normal',
    fontWeight: '700',
    lineHeight: 'normal',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
}));
